import React, { useState } from 'react';
import { Radio, DatePicker } from 'antd';
import moment from 'moment';
const { RangePicker } = DatePicker;
const getLastDays = (lastDay) => {
  const current = Date.now();
  const last = current - 3600 * 24 * 1000 * lastDay;
  return moment(last);
};
const ChooseTime = (options) => {
  const timeRadioOptions = [
    { label: '当月', value: 'month' },
    { label: '当年', value: 'year' },
    { label: '历史总量', value: 'history' },
    { label: '选择日期', value: 'date' },
  ];
  const dateFormat = 'YYYY-MM-DD';
  const [timeRadioValue, setTimeRadioValue] = useState(
    options.timeRadioValue || 'month',
  );
  const [pickerDate, setPickerDate] = useState([
    getLastDays(7),
    getLastDays(0),
  ]);
  const onOpenChange = (open, type) => {};
  const onChangeTimeRadio = (e) => {
    console.log('radio checked', e.target.value);
    if (e.target.value !== 'date') {
      options.onTimeChange(e.target.value);
    } else {
      options.onTimeChange(e.target.value, [
        moment(pickerDate[0]).format(dateFormat),
        moment(pickerDate[1]).format(dateFormat),
      ]);
    }
    setTimeRadioValue(e.target.value);
  };
  const onChangeTimeRangePicker = (e) => {
    setPickerDate(e);
    options.onTimeChange('date', [
      moment(e[0]).format(dateFormat),
      moment(e[1]).format(dateFormat),
    ]);
  };
  return (
    <div style={{ marginBottom: '10px' }}>
      <Radio.Group
        options={timeRadioOptions}
        onChange={onChangeTimeRadio}
        value={timeRadioValue}
        optionType="button"
        buttonStyle="solid"
        style={{ marginRight: '20px' }}
      />
      {timeRadioValue === 'date' ? (
        <RangePicker
          value={pickerDate}
          allowClear={false}
          onOpenChange={(open) => {
            onOpenChange(open);
          }}
          onChange={onChangeTimeRangePicker}
          picker="date"
          format={dateFormat}
        />
      ) : (
        ''
      )}
    </div>
  );
};
export default ChooseTime;
